/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordSetAttestationData
 */
export interface PasswordSetAttestationData {
    /**
     * 
     * @type {string}
     * @memberof PasswordSetAttestationData
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordSetAttestationData interface.
 */
export function instanceOfPasswordSetAttestationData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function PasswordSetAttestationDataFromJSON(json: any): PasswordSetAttestationData {
    return PasswordSetAttestationDataFromJSONTyped(json, false);
}

export function PasswordSetAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordSetAttestationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function PasswordSetAttestationDataToJSON(value?: PasswordSetAttestationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

